export function getUserInfoByLocalStorage(){
    try{
        var user = JSON.parse(localStorage.getItem('user'));
        return user;
    }catch(error){
        window.location.href = getLoginPage();
        return null;
    }
}

export function authHeader() {
    // return authorization header with jwt token
    let user = getUserInfoByLocalStorage();

    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        return {};
    }
}

export function getToken(){
    
    try {
        let user =  getUserInfoByLocalStorage();
        if (user && user.token) {
            // return jwt token
            return user.token;
        } else {
            return "";
        }
    } catch (e) {
        localStorage.removeItem('user');
        window.location.href = getLoginPage();
        return "";
    }
    
}

export const parseJwtPayload = (token) => {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        localStorage.removeItem('user');
        window.location.href = getLoginPage();
        return null;
    }
};

export const getLoginPage = () => {
    return process.env.BASE_URL + 'auth/login';
};